import { Button, ButtonProps, useToast } from '@chakra-ui/react';
import { copyText } from '@pelicargo/ui';
import { HiClipboardCopy } from 'react-icons/hi';

type Props = ButtonProps & {
  text: string;
};

export const CopyButton = ({ text, ...rest }: Props) => {
  const toast = useToast();
  return (
    <Button
      size="xs"
      variant="ghost"
      leftIcon={<HiClipboardCopy />}
      opacity="0"
      _groupHover={{ opacity: 1 }}
      onClick={() => {
        copyText(text);
        toast({
          colorScheme: 'green',
          title: 'Copied!',
          duration: 1000,
        });
      }}
      {...rest}
    >
      Copy
    </Button>
  );
};
